import React, { useState, useEffect } from "react";
import Header from "./components/Header";
import Navigation from "./components/Navigation";
import FoodDetective from "./components/FoodDetective";
import History from "./components/History";
import Kitchen from "./components/Kitchen";
import Footer from "./components/Footer";
import AlphaGalModal from "./components/AlphaGalModal";
import { API_CONFIG } from "./config";

function App() {
  const [currentView, setCurrentView] = useState("detective");
  const [showAlphaGalModal, setShowAlphaGalModal] = useState(false);
  const [foodHistory, setFoodHistory] = useState([]);

  // Load food history from localStorage on component mount
  useEffect(() => {
    const savedHistory = localStorage.getItem("danaFoodHistory");
    if (savedHistory) {
      try {
        setFoodHistory(JSON.parse(savedHistory));
      } catch (error) {
        console.error("Error loading food history:", error);
      }
    }
  }, []);

  // Save food history to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("danaFoodHistory", JSON.stringify(foodHistory));
  }, [foodHistory]);

  const addToHistory = (foodName, isSafe, confidence, details) => {
    const newEntry = {
      id: Date.now(),
      name: foodName,
      isSafe,
      confidence,
      details,
      timestamp: new Date().toLocaleString(),
    };
    setFoodHistory((prev) => [newEntry, ...prev]);
  };

  const clearHistory = () => {
    setFoodHistory([]);
  };

  return (
    <div className="app">
      <Header />
      <Navigation
        currentView={currentView}
        setCurrentView={setCurrentView}
        setShowAlphaGalModal={setShowAlphaGalModal}
      />

      <main className="main-content">
        {currentView === "detective" && (
          <FoodDetective addToHistory={addToHistory} />
        )}
        {currentView === "history" && (
          <History foodHistory={foodHistory} clearHistory={clearHistory} />
        )}
        {currentView === "kitchen" && <Kitchen />}
      </main>

      <Footer />

      {showAlphaGalModal && (
        <AlphaGalModal onClose={() => setShowAlphaGalModal(false)} />
      )}
    </div>
  );
}

export default App;
